import { useState } from "react";
import { useSelector } from "react-redux";

import api from "../../../api/api";
import HintModal from "../common/hint-modal";
import avatarImage from "../../../assets/images/avatar.svg";
import ChatSendingPopup from "../../Forms/common/ChatSendingPopup";
import UserChatBubble from "../../Forms/FirmUserBtn";
import { currencyFormat } from "../../../Utils/helper";

import RoleSelectionModal from "./modals/role-selection-modal";
import { useGetFirmUserTypes, useGetUserRoles } from "./hooks/useGetRolesPageApi";

const UserRoles = () => {
  // const heading = "Set the main and possible user roles for each user along with their hourly billing rate";
  const points = [
    "Main Role is the default role the user is assigned if the user is assigned to a case automatically without setting a specific role for that case and represents the main role that user holds at the firm.",
    "Hourly Billing Rate is the billing rate used to automatically calculate the billing value for that user on a case based on the time spent on the case.",
    "Firm User Roles are the possible roles the user can be selected for on a case.",
    "Click a user row to edit these values.",
  ];
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);

  const {
    data: getUserRoles,
    loading: _userRolesLoading,
    error: _userRolesError,
    refetch,
  } = useGetUserRoles();
  const {
    data: getFirmUserType,
    loading: _firmUserTypeLoading,
    error: _firmUserTypeError,
  } = useGetFirmUserTypes();

  const [showModal, setShowModal] = useState(false);
  const [showHints, setShowHints] = useState(false);

  const [chatData, setChatData] = useState(null);
  const [chatModal, setChatModal] = useState(false);
  const openChatModel = (event, data) => {
    event?.stopPropagation();
    setChatData(data);
    setChatModal(!chatModal);
  };
  const handleHintToggle = () => {
    setShowHints(!showHints);
  };

  const [selectedUser, setSelectedUser] = useState({});
  const handleEditUser = (userRole) => {
    setSelectedUser(userRole);
    setShowModal(true);
  };

  const handleSave = async (selectedRoles) => {
    try {
      await api.post("/api/firmsetting-page/update-user-role-rate/", selectedRoles);

      refetch();
      setShowModal(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="tab-pane fade firm-settings-user-perms-fs active show">
      <div
        className="d-flex justify-content-end m-b-5"
        onClick={() => {
          handleHintToggle();
        }}
      >
        <i className="ic ic-19 ic-help-2 cursor-pointer" />
      </div>
      <div className="tab-content">
        <table
          className={
            "table table-borderless table-striped table-treatment has-specialty-icon has-height-25 block-table m-r-5"
          }
          id="treatment-summary-table"
        >
          <thead>
            <tr id="tb-header">
              <th
                style={{
                  minWidth: "25px",
                  width: "25px",
                  maxWidth: "25px",
                  padding: 0,
                }}
              />
              <th className="text-uppercase text-center td-autosize">Main Role</th>
              <th aria-hidden="true" style={{ minWidth: "25px", width: "25px", padding: 0 }} />
              <th className="text-uppercase text-center">Firm User Roles</th>
              <th aria-hidden="true" style={{ minWidth: "25px", width: "25px", padding: 0 }} />
              <th className="text-uppercase text-center td-autosize">Firm User</th>
            </tr>
          </thead>
          <tbody>
            {getUserRoles &&
              getUserRoles?.map((userRole, idx) => (
                <tr
                  key={userRole.id}
                  className="cursor-pointer"
                  style={{ height: "35px" }}
                  onClick={() => handleEditUser(userRole)}
                  tabIndex={0}
                  onKeyDown={(event) => {
                    if (
                      event.target === event.currentTarget &&
                      (event.key === "Enter" || event.key === " ")
                    ) {
                      event.preventDefault();
                      handleEditUser(userRole);
                    }
                  }}
                >
                  <td
                    className="text-center"
                    style={{
                      color: "var(--primary-25)",
                      fontWeight: "600",
                      minWidth: "25px",
                      width: "25px",
                      maxWidth: "25px",
                      padding: 0,
                    }}
                  >
                    {idx + 1}
                  </td>
                  <td className="text-center td-autosize font-weight-semibold">
                    {userRole?.for_firmusertype
                      ? userRole.for_firmusertype?.name
                      : getFirmUserType && getFirmUserType[0]?.name}
                  </td>
                  <td aria-hidden="true" style={{ minWidth: "25px", width: "25px", padding: 0 }} />
                  <td>
                    <span
                      style={{
                        gap: "5px",
                      }}
                      className="d-flex p-t-5 p-b-5 justify-content-center align-items-center text-center flex-wrap btn-gaps"
                    >
                      {userRole?.firm_roles?.[0]?.for_firm_usertype?.map((firmUserType) => {
                        const hourlyRate = userRole?.hourly_rates?.find(
                          (rate) => rate?.for_role?.id === firmUserType.id
                        )?.rate;
                        const numericHourlyRate = Number(hourlyRate);
                        const hasHourlyRate =
                          Number.isFinite(numericHourlyRate) && numericHourlyRate > 0;

                        return (
                          <div
                            className="d-flex flex-row align-items-center justify-content-center text-nowrap"
                            key={firmUserType.id}
                          >
                            <span
                              style={{
                                background: "var(--primary)",
                                color: "#fff",
                                fontWeight: "600",
                                padding: "0 5px",
                                borderRadius: "2px",
                              }}
                              className="height-21 d-flex align-items-center"
                            >
                              <span>{firmUserType.name}</span>
                              {hasHourlyRate && (
                                <span
                                  className="m-l-5 p-l-5"
                                  style={{ borderLeft: "1px solid rgba(255, 255, 255, 0.5)" }}
                                >
                                  {currencyFormat(numericHourlyRate)}/hr
                                </span>
                              )}
                            </span>
                          </div>
                        );
                      })}
                    </span>
                  </td>
                  <td aria-hidden="true" style={{ minWidth: "25px", width: "25px", padding: 0 }} />
                  <td className="text-center td-autosize">
                    <div className="d-flex p-t-5 p-b-5 align-items-center justify-content-center">
                      <UserChatBubble
                        first_name={userRole?.user?.first_name}
                        last_name={userRole?.user?.last_name}
                        profilePic={userRole?.profile_pic_29p ?? ""}
                        onClick={(e) => openChatModel(e, userRole)}
                        isActive={userOnlineStatus?.[userRole?.user?.id]?.isOnline ?? false}
                        is_active={userRole?.user?.is_active}
                      />
                    </div>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <RoleSelectionModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          handleSave={handleSave}
          userRoles={getFirmUserType}
          userId={selectedUser?.id}
          refetch={refetch}
          userDefinedRoles={getUserRoles}
          getFirmUserType={getFirmUserType}
          userRole={selectedUser}
        />
      )}
      {showHints && <HintModal show={showHints} handleClose={handleHintToggle} points={points} />}
      {chatModal && (
        <ChatSendingPopup
          data={chatData}
          show={chatModal}
          handleClose={() => setChatModal(false)}
          first_name={chatData?.user?.first_name}
          last_name={chatData?.user?.last_name}
          userId={chatData?.user?.id}
          is_active={chatData?.user?.is_active}
          profilePic={chatData?.profile_pic_29p || avatarImage}
        />
      )}
    </div>
  );
};

export default UserRoles;
